import React from "react";
import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";

function MergeFieldsSelect({
  onSelect = () => null,
  excludeFields = [],
}: {
  onSelect: (value: string) => void;
  excludeFields?: string[];
}) {
  // Define all merge field options
  const allMergeFields = [
    { value: "{{greeting}}", label: "Greeting" },
    { value: "{{guest_account}}", label: "Guest Account" },
    { value: "{{guest_first_name}}", label: "Guest First Name" },
    { value: "{{guest_last_name}}", label: "Guest Last Name" },
    { value: "{{guest_logic_field}}", label: "Guest Logic Field" },
    { value: "{{guest_logic_field_2}}", label: "Guest Logic Field 2" },
    { value: "{{guest_phone}}", label: "Guest Phone" },
    { value: "{{host_company}}", label: "Host Company" },
    { value: "{{host_first_name}}", label: "Host First Name" },
    { value: "{{host_last_name}}", label: "Host Last Name" },
    { value: "{{host_location}}", label: "Host Location" },
    { value: "{{host_title}}", label: "Host Title" },
    { value: "{{host_signature}}", label: "Host Signature" },
    { value: "{{meeting_date_time}}", label: "Meeting Date & Time" },
    { value: "{{meeting_day_of_week}}", label: "Meeting Day of Week" },
    { value: "{{meeting_duration}}", label: "Meeting Duration" },
    { value: "{{meeting_link}}", label: "Meeting Link" },
    { value: "{{meeting_month_day}}", label: "Meeting Month & Day" },
    { value: "{{meeting_time}}", label: "Meeting Time" },
    { value: "{{time_casual_day}}", label: "Time Casual Day" },
    { value: "{{time_number_date}}", label: "Time Number Date" },
    { value: "{{previous_year}}", label: "Previous Year" },
    { value: "{{current_year}}", label: "Current Year" },
    { value: "{{next_year}}", label: "Next Year" },
    { value: "{{guest_custom_field_1}}", label: "Guest Custom Field 1" },
    { value: "{{guest_custom_field_2}}", label: "Guest Custom Field 2" },
    { value: "{{guest_custom_field_3}}", label: "Guest Custom Field 3" },
    { value: "{{guest_custom_field_4}}", label: "Guest Custom Field 4" },
    { value: "{{guest_custom_field_5}}", label: "Guest Custom Field 5" },
    { value: "{{guest_custom_field_6}}", label: "Guest Custom Field 6" },
    { value: "{{guest_custom_field_7}}", label: "Guest Custom Field 7" },
    { value: "{{guest_custom_field_8}}", label: "Guest Custom Field 8" },
    { value: "{{guest_custom_field_9}}", label: "Guest Custom Field 9" },
    { value: "{{guest_custom_field_10}}", label: "Guest Custom Field 10" },
  ];

  // Filter out excluded fields
  const availableFields = allMergeFields.filter(
    (field) => !excludeFields.includes(field.value),
  );

  return (
    <FormControl sx={{ width: "175px" }}>
      <Select
        sx={{ marginLeft: 2 }}
        labelId="merge-tags-select"
        id="merge-tags-select"
        value="placeholder"
        variant="standard"
        onChange={(event: SelectChangeEvent) => {
          onSelect(event.target.value);
        }}
      >
        <MenuItem value="placeholder" style={{ display: "none" }}>
          Merge Fields
        </MenuItem>
        {availableFields.map((field) => (
          <MenuItem key={field.value} value={field.value}>
            {field.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default MergeFieldsSelect;
